/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ShiftReportsRow,
    ShiftReportsRowFromJSON,
    ShiftReportsRowFromJSONTyped,
    ShiftReportsRowToJSON,
} from './';

/**
 * 乗務リポートリスト
 * @export
 * @interface ShiftReportsList
 */
export interface ShiftReportsList {
    /**
     * 
     * @type {Array<ShiftReportsRow>}
     * @memberof ShiftReportsList
     */
    shiftReports?: Array<ShiftReportsRow>;
}

export function ShiftReportsListFromJSON(json: any): ShiftReportsList {
    return ShiftReportsListFromJSONTyped(json, false);
}

export function ShiftReportsListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShiftReportsList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'shiftReports': !exists(json, 'shift_reports') ? undefined : ((json['shift_reports'] as Array<any>).map(ShiftReportsRowFromJSON)),
    };
}

export function ShiftReportsListToJSON(value?: ShiftReportsList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'shift_reports': value.shiftReports === undefined ? undefined : ((value.shiftReports as Array<any>).map(ShiftReportsRowToJSON)),
    };
}


